module.exports = __webpack_public_path__ + "img/6ddb819.png";